const industryThemeMap = {
  '#006CFF': {
    '--industry-primary-color': '#056DFF',
    '--industry-right-bar-bg-color':
      'linear-gradient(170deg, #27DCE9 -0.21%, #3586FF 100%)',
  },
  '#1EAA55': {
    '--industry-primary-color': '#1EAA55',
    '--industry-right-bar-bg-color':
      'linear-gradient(170deg, #19E166 -0.21%, #19D7E1 100%)',
  },
  '#FFA800': {
    '--industry-primary-color': '#EAA01F',
    '--industry-right-bar-bg-color':
      'linear-gradient(170deg, #FFC342 -0.21%, #FA7646 100%)',
  },
  '#FF4444': {
    '--industry-primary-color': '#DD3C3C',
    '--industry-right-bar-bg-color':
      'linear-gradient(170deg, #FD4141 -0.21%, #ED955E 100%)',
  },
  '#9800FF': {
    '--industry-primary-color': '#8332BB',
    '--industry-right-bar-bg-color':
      'linear-gradient(170deg, #D54AC3 -0.21%, #615EED 100%)',
  },
  '#30CC9D': {
    '--industry-primary-color': '#219F77',
    '--industry-right-bar-bg-color':
      'linear-gradient(170deg, #44C49B -0.21%, #61D16E 100%)',
  },
  '#FF6E00': {
    '--industry-primary-color': '#E96F13',
    '--industry-right-bar-bg-color':
      'linear-gradient(170deg, #FAA261 -0.21%, #F6563D 100%)',
  },
  '#FF007D': {
    '--industry-primary-color': '#BC2B72',
    '--industry-right-bar-bg-color':
      'linear-gradient(170deg, #FB7786 -0.21%, #CB3DF6 100%)',
  },
  '#00BDFF': {
    '--industry-primary-color': '#0096CB',
    '--industry-right-bar-bg-color':
      'linear-gradient(170deg, #59DAEB -0.21%, #2285FF 100%)',
  },
  '#274393': {
    '--industry-primary-color': '#274393',
    '--industry-right-bar-bg-color':
      'linear-gradient(170deg, #2550CB -0.21%, #6B2793 100%)',
  },
  '#279387': {
    '--industry-primary-color': '#057B77',
    '--industry-right-bar-bg-color':
      'linear-gradient(170deg, #27E9D6 -0.21%, #2EB0EA 100%)',
  },
}
function generateBackground(primaryColor) {
  return industryThemeMap[primaryColor] || industryThemeMap['#1EAA55']
}

export default generateBackground
